import { ColumnType } from '../table/constants/column-type';
import { ITableColumn } from '../table/models/table-column';

export class Table {
    public static readonly DefaultTakeOptions = [10, 25, 50, 100];
    public static readonly MaxCellLength = 100;
    public static readonly NoDataMessage = "There isn't any data available at this time.";
    public static readonly Multiple = 'Multiple';
    public static readonly NullAmount = '----';
}

export class TableColumns {
    public static readonly RowCounter: ITableColumn = {
        type: ColumnType.RowCounter,
        width: '4.5rem'
    };

    public static Spacer(width: string): ITableColumn {
        return {
            type: ColumnType.Spacer,
            width
        };
    }
}
